module.exports = __webpack_public_path__ + "img/logo_starscan.9b114fd9.png";